import SpotlightConstants from '@/utils/enums/spotlightConstants';

const Features = () =>
  import(/* webpackChunkName: "categories" */ '@/modules/spotlight/containers/categories/Features.vue');
const Highlights = () =>
  import(/* webpackChunkName: "categories" */ '@/modules/spotlight/containers/categories/Highlights.vue');
const Protection = () =>
  import(/* webpackChunkName: "categories" */ '@/modules/spotlight/containers/categories/Protection.vue');
const Awards = () =>
  import(/* webpackChunkName: "categories" */ '@/modules/spotlight/containers/categories/Awards.vue');
const IncentivesAndRebates = () =>
  import(/* webpackChunkName: "categories" */ '@/modules/spotlight/containers/categories/IncentivesAndRebates.vue');

export default [
  {
    path: '',
    redirect: { path: SpotlightConstants.categories.HIGHLIGHTS },
  },
  {
    path: SpotlightConstants.categories.FEATURES,
    component: Features,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
      headerStyleClasses: 'mb-0',
      category: SpotlightConstants.categories.FEATURES,
    },
  },
  {
    path: SpotlightConstants.categories.HIGHLIGHTS,
    component: Highlights,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
      headerStyleClasses: 'mb-0',
      category: SpotlightConstants.categories.HIGHLIGHTS,
    },
  },
  {
    path: SpotlightConstants.categories.PROTECTION,
    component: Protection,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
      headerStyleClasses: 'mb-0',
      category: SpotlightConstants.categories.PROTECTION,
    },
  },
  {
    path: SpotlightConstants.categories.AWARDS_AND_RATINGS,
    component: Awards,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
      headerStyleClasses: 'mb-0',
      category: SpotlightConstants.categories.AWARDS_AND_RATINGS,
    },
  },
  {
    path: SpotlightConstants.categories.INCENTIVES_AND_REBATES,
    component: IncentivesAndRebates,
    meta: {
      headerIcon: 'back',
      product: 'Spotlight',
      headerStyleClasses: 'mb-0',
      category: SpotlightConstants.categories.INCENTIVES_AND_REBATES,
    },
  },
];
